import _defineProperty from "/var/www/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var __jsx = React.createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import Head from 'next/head';
import { useRouter } from 'next/router';
import { getUrlFromRoute } from '@app/helpers';
import { jsx as _jsx } from "react/jsx-runtime";
function extractLocationData(location, opportunityUrl) {
  if (location) {
    return {
      "@type": "Place",
      "name": location.name,
      "address": location.formatted_address
    };
  }
  return {
    "@type": "VirtualLocation",
    "url": opportunityUrl
  };
}
function extractPaymentData(paymentInfo, offerUrl, createDate) {
  var initalData = {
    "@type": "Offer",
    "url": offerUrl,
    "availability": "https://schema.org/InStock",
    "validFrom": createDate
  };
  if (paymentInfo) {
    return paymentInfo.map(function (_ref) {
      var cost = _ref.cost,
        currency = _ref.currency;
      return _objectSpread(_objectSpread({}, initalData), {}, {
        "price": cost,
        "priceCurrency": currency.toUpperCase()
      });
    });
  }
  return _objectSpread(_objectSpread({}, initalData), {}, {
    "price": "0",
    "priceCurrency": "USD"
  });
}
function OpportunityJsonLd(_ref2) {
  var title = _ref2.title,
    description = _ref2.description,
    url = _ref2.url,
    location = _ref2.location,
    images = _ref2.images,
    offerUrl = _ref2.offerUrl,
    organisation = _ref2.organisation,
    startDate = _ref2.startDate,
    endDate = _ref2.endDate,
    createDate = _ref2.createDate,
    paymentInfo = _ref2.paymentInfo;
  var router = useRouter();
  var organisationUrl = getUrlFromRoute('organisation_view', {
    params: {
      slug: organisation.slug
    },
    locale: router.locale
  });
  var jsonData = {
    "@context": "https://schema.org",
    "@type": "MusicEvent",
    "location": extractLocationData(location, url),
    "name": title,
    "description": description,
    "image": images,
    "url": url,
    "offers": extractPaymentData(paymentInfo, offerUrl, createDate),
    "eventAttendanceMode": "https://schema.org/".concat(location ? 'Offline' : 'Online', "EventAttendanceMode"),
    "eventStatus": "https://schema.org/EventScheduled",
    "organizer": {
      "@type": "Organization",
      "name": organisation.name,
      "url": organisationUrl
    }
  };
  if (startDate) {
    jsonData.startDate = startDate;
  }
  if (endDate) {
    jsonData.endDate = endDate;
  }
  return /*#__PURE__*/_jsx(Head, {
    children: /*#__PURE__*/_jsx("script", {
      type: "application/ld+json"
      // eslint-disable-next-line react/no-danger
      ,
      dangerouslySetInnerHTML: {
        __html: JSON.stringify(jsonData)
      }
    }, "jsonld-event")
  });
}
OpportunityJsonLd.defaultProps = {
  location: null,
  endDate: null,
  paymentInfo: null
};
export default OpportunityJsonLd;